/* global google */
/*
 * Mapeo canónico `google.maps.places.PlaceResult` → `Commerce['address']` estructurado.
 * Mismo criterio de `address_components` que usa el AddressForm del panel; centralizado para que el
 * portal partner (alta/configuración) y cualquier otro consumidor del mapa compartan la fuente única.
 */
import type { Commerce } from '@interfaces/general';

type CommerceAddress = NonNullable<Commerce['address']>;

export const mapPlaceToAddress = (place: google.maps.places.PlaceResult): CommerceAddress => {
  const components = place.address_components || [];
  const getComponent = (type: string) =>
    components.find((component) => component.types.includes(type))?.long_name || '';
  const loc = place.geometry?.location;

  return {
    country: getComponent('country') || 'Mexico',
    state: getComponent('administrative_area_level_1'),
    city: getComponent('locality'),
    neighborhood: getComponent('neighborhood') || getComponent('sublocality'),
    postalCode: getComponent('postal_code'),
    street: getComponent('route'),
    exteriorNumber: getComponent('street_number'),
    interiorNumber: '',
    fullAddress: place.formatted_address || '',
    latitude: loc ? loc.lat() : 0,
    longitude: loc ? loc.lng() : 0,
  };
};

export default mapPlaceToAddress;
